module.exports = __webpack_public_path__ + "static/media/ReleaseNotes.2f77c9fd.mdx";